// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from '@/router'
import store from '@/store/store'
import Vuelidate from 'vuelidate'
import VueLazyload from 'vue-lazyload'
import Vue2TouchEvents from 'vue2-touch-events'
import VueYoutube from 'vue-youtube'
import VueAnalytics from 'vue-analytics'
import VueScrollTo from 'vue-scrollto'
import VueMeta from 'vue-meta'

import './registerServiceWorker'

// Root
import App from '@/app/app.vue'

// Components
import Icon from 'vue-awesome/components/Icon'
import TagTemplate from '@/components/tagTemplate/tagTemplate'

// Font awesome list
import 'vue-awesome/icons/street-view'
import 'vue-awesome/icons/play'
import 'vue-awesome/icons/pause'
import 'vue-awesome/icons/expand'
import 'vue-awesome/icons/compress'
import 'vue-awesome/icons/volume-down'
import 'vue-awesome/icons/volume-mute'

// Directives
import Focus from '@/directives/focus'

// Helpers
import { setLazyloaded } from '@/helpers/lazyload'

// Assets
import lazyLoaderImg from '@/assets/lazy-loader.svg'

Vue.config.productionTip = false

const isProd = process.env.NODE_ENV === 'production'

Vue.use(VueAnalytics, {
  id: 'UA-126575569-3',
  router,
  debug: {
    enabled: !isProd,
    sendHitTask: isProd
  }
})

Vue.use(VueYoutube)
Vue.use(Vuelidate)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: lazyLoaderImg,
  attempt: 1,
  lazyComponent: true,
  // throttleWait: 3000,
  adapter: {
    loaded (res) {
      const attributes = res.el.attributes

      if (attributes['data-lazyloaded']) {
        setLazyloaded(store, attributes)
      }
    }
  }
})
Vue.use(Vue2TouchEvents, {
  swipeTolerance: 60
})
Vue.use(VueScrollTo, {
  duration: 1300
})
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.component('icon', Icon)
Vue.component('tag-template', TagTemplate)

Vue.directive('focus', Focus)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
